$(document).ready(function(){
  
$('.section-review-main').not('.slick-initialized').slick({ 
    slidesToShow:3,
    slidesToScroll:1, 
    centerMode:false,
    pauseOnHover: false,
    infinite:true,    
  	arrows: true,
    dots:false,  
    prevArrow: '<button class="slick-arrow-review-main slick-arrow-review-left" aria-label="Previous Slide"><span class="slick-arrow-collection prev-arrow" ><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5.39275 7.37506L8.74525 4.02255L7.86137 3.13867L3 8.00006L7.86137 12.8614L8.74525 11.9775L5.39275 8.62506H13V7.37506H5.39275Z" fill="white"/></svg></span></button>',
    nextArrow: '<button class="slick-arrow-review-main slick-arrow-review-right" aria-label="Next Slide"><span class="slick-arrow-collection next-arrow" ><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.6073 7.37506L7.25475 4.02255L8.13863 3.13867L13 8.00006L8.13863 12.8614L7.25475 11.9775L10.6073 8.62506H3V7.37506H10.6073Z" fill="white"/></svg></span></button>',
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '20px'
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '8px',
      }
    }
  ],
    customPaging : function(slider, i) {
    var thumb = $(slider.$slides[i]).data();
      return (i + 1);
    }
  }); 
$(".review-sec-prev-btn").click(function () {
		$(".section-review-main").slick("slickPrev");
	});
	$(".review-sec-next-btn").click(function () {
		$(".section-review-main").slick("slickNext");
	});  
	$(".review-sec-prev-btn").addClass("slick-disabled");  
	$(".section-review-main").on("afterChange", function () {
		if ($(".slick-prev").hasClass("slick-disabled")) {
			$(".review-sec-prev-btn").addClass("slick-disabled");
		} else {
			$(".review-sec-prev-btn").removeClass("slick-disabled");
		}
		if ($(".slick-next").hasClass("slick-disabled")) {
			$(".review-sec-next-btn").addClass("slick-disabled");
		} else {
			$(".review-sec-next-btn").removeClass("slick-disabled");
		}
	});
  
}); 